import React from "react";
import { Tooltip } from "@cdk-uip/react-tooltip";
import { Icon } from "@cdk-uip/react-icon";
import "./InvoiceConfigurationHelpTooltip.css";

class InvoiceConfigurationHelpTooltip extends React.Component {
  render() {
    const { config } = this.props;
    return (
      <React.Fragment>
        <div
          id={`mmi-config-help-icon__${config.id}`}
          className="mmi-config-help-icon"
        >
          <Icon type="button">info</Icon>
        </div>
        <Tooltip htmlFor={`mmi-config-help-icon__${config.id}`}>
          <img
            id={`mmi-config-help-content__${config.id}`}
            src={config.image}
            alt={config.title}
          ></img>
        </Tooltip>
      </React.Fragment>
    );
  }
}

export default InvoiceConfigurationHelpTooltip;
